import { memo } from "react";

/**
 * The 3x3 Novi tile grid that opens the application switcher.
 *
 * Ported verbatim from novi-apps' `AppSwitcherMark`, brand hexes and all: this
 * mark identifies the suite rather than this app, so it must not drift when EVA
 * restyles or switches theme.
 */
function IconAppSwitcher({ size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="6" height="6" rx="1" fill="#FFC612" />
      <rect x="11" y="3" width="6" height="6" rx="1" fill="#EE3A26" />
      <rect x="19" y="3" width="6" height="6" rx="1" fill="#EE3A26" />
      <rect x="19" y="11" width="6" height="6" rx="1" fill="#EE3A26" />
      <rect x="19" y="19" width="6" height="6" rx="1" fill="#FFC612" />
      <rect x="11" y="11" width="6" height="6" rx="1" fill="#FFC612" />
      <rect x="3" y="11" width="6" height="6" rx="1" fill="#7FC99B" />
      <rect x="11" y="19" width="6" height="6" rx="1" fill="#7FC99B" />
      <rect x="3" y="19" width="6" height="6" rx="1" fill="#516CB4" />
    </svg>
  );
}

export default memo(IconAppSwitcher);
